import { MODE_RACCORDEMENT } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case MODE_RACCORDEMENT.INDIVIDUEL:
        return 'Raccordement individuel';
      case MODE_RACCORDEMENT.COLLECTIF:
        return 'Raccordement collectif';
      case MODE_RACCORDEMENT.NSP:
        return 'Je ne sais pas ';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/mode-raccordement.filter.js